import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption, ListOptionRequest } from '../modules/tcm-core.module';
import { UserListOptionRequest, UserOptionWithUserInfo, UserRegionViewModel } from '../models/users';

@Injectable({
  providedIn: 'root'
})
export class UserDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getUserOptionsAsync(query: string, timeout: Promise<any> = null): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('users/options', request, timeout);
  }

  public getUserOptionsByClinicAsync(query: string, clinicId: number = null, timeout: Promise<any> = null): Promise<ListOption<number>[]> {
    const request: UserListOptionRequest = { searchString: query, clinicId: clinicId };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('users/OptionsByClinic', request, timeout);
  }

  public getUserOptionsWithUserInfoAsync(query: string, cancellationToken: Promise<any>): Promise<UserOptionWithUserInfo[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<UserOptionWithUserInfo[]>('users/optionsWithUserInfo', request, cancellationToken);
  }

  public getNonProviderUserOptionsFunc(query: string, timeout: Promise<any> = null): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('users/nonProviderUserOptions', request, timeout);
  }

  public checkEmailExists(email: string, userId: number, timeout?: Promise<any>): Promise<boolean> {
    const data = { email: email, userId: userId };

    return this.httpClient.getJsonAsync<boolean>('users/checkEmailExists', data, timeout, false);
  }

  public checkErpIdExistsAsync(erpId: any, userId?: number, timeout?: Promise<any>): Promise<boolean> {
    const request = { erpId: erpId, userId: userId };

    return this.httpClient.getJsonAsync<boolean>('Users/CheckUserErpIdExist', request, timeout);
  }

  public getAllNotLinkedRegionsAsync(userId: number, apiKeyId: number, cancellationToken: Promise<any>): Promise<number[]> {
    return this.httpClient.getJsonAsync('Users/GetAllNotLinkedRegions', { userId, apiKeyId }, cancellationToken);
  }

  public getInactiveProvidersAsync(userId: number, cancellationToken: Promise<any>): Promise<string[]> {
    return this.httpClient.getJsonAsync('Users/GetInactiveProviders', { userId }, cancellationToken);
  }
}
